import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import ModalCS from '../../../common/ComponentesCS/ModalCS';
import { CatalogsService, invoicesService, ProjectsService } from '../../../common/services';
import TextFieldCS from '../../../common/ComponentesCS/TextFieldCS';
import DropDownListCS from '../../../common/ComponentesCS/DropDownListCS';
import { Button } from '@material-ui/core';
// import "../../../styles/site.css";

const buildXmlProjectData = (xmlFile) => {
    const invoice = xmlFile?.invoice || {};
    return {
        Currency: invoice.currency,
        Invoices: invoice.itemsNormalized ?? invoice.items ?? [],
        NitSender: invoice.nitSender,
        NitReceiver: invoice.nitReceiver,
        CUFE: invoice.cufe,
        TotalAmount: invoice.totalAmount,
        TaxAmount: invoice.taxAmount ?? 0,
        InvoiceNumber: invoice.invoiceNumber,
        Proveedor: invoice.prov,
        FileUrl: xmlFile?.fileUrl ?? null,
    };
};

const CreateProjectDialog = ({ show, onClose, onProjectCreated, onProjectCreationError, clientData }) => {
    const [projectTypes, setProjectTypes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingFile, setLoadingFile] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);

    // Estados del formulario
    const [formData, setFormData] = useState({
        nombreProyecto: '',
        tipoProyecto: projectTypes.length > 0 ? projectTypes[0].value : 0,
        xmlFile: null
    });

    const [errors, setErrors] = useState({});

    // Función para verificar si el formulario está completo
    const isFormValid = () => {
        return (
            formData.nombreProyecto.trim() !== '' &&
            formData.tipoProyecto !== '' &&
            formData.xmlFile !== null
        );
    };

    useEffect(() => {
        const fetchProjectTypes = async () => {
            // Solo hacer la petición si no se han cargado los datos antes
            if (!dataLoaded && show) {
                try {
                    setLoading(true);
                    // Nota: Los parámetros type, login, pass deben ser configurados según tus necesidades
                    const response = await CatalogsService.getProjectTypes();
                    let formattedResponse = response.map(type => ({
                        value: type.tipoProyecto,
                        label: type.tipoProyecto
                    }));

                    // Agregar opción por defecto al inicio
                    formattedResponse.unshift({
                        value: '',
                        label: ''
                    });

                    setProjectTypes(formattedResponse);
                    setDataLoaded(true); // Marcar que los datos ya se cargaron
                } catch (error) {
                    setProjectTypes([]);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchProjectTypes();
    }, [show, dataLoaded]);

    // Función para manejar cambios en cualquier TextField
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };

    // Función para manejar la carga de archivo XML
    const handleFileChange = (event) => {
        setLoadingFile(true);
        const file = event.target.files[0];
        if (file) {
            // Validar que sea un archivo XML
            if (file.type === 'text/xml' || file.name.endsWith('.xml')) {
                // handleInputChange('xmlFile', file);
                setFormData(prevFormData => ({
                    ...prevFormData,
                    'file': file
                }));
                invoicesService.convertXML(file).then((data) => {
                    setLoadingFile(false);
                    handleInputChange({ target: { name: 'xmlFile', value: data } });
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        'xmlFile': data,
                    }));

                }).catch((error) => {
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        'file': null
                    }));
                });

            } else {
                setErrors(prev => ({
                    ...prev,
                    xmlFile: 'Por favor selecciona un archivo XML válido'
                }));
            }
        }
    };

    // Función para eliminar el archivo XML seleccionado
    const handleRemoveFile = () => {
        setFormData(prevFormData => ({
            ...prevFormData,
            xmlFile: null,
            file: null
        }));
        // Limpiar el input file
        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) {
            fileInput.value = '';
        }
        // Limpiar errores relacionados con el archivo
        setErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors.xmlFile;
            return newErrors;
        });
    };

    // Función para validar el formulario
    const validateForm = () => {
        const newErrors = {};

        if (!formData.nombreProyecto.trim()) {
            newErrors.nombreProyecto = 'El nombre del proyecto es requerido';
        }

        if (!formData.tipoProyecto) {
            newErrors.tipoProyecto = 'Debe seleccionar un tipo de proyecto';
        }

        if (!formData.xmlFile) {
            newErrors.xmlFile = 'Debe cargar un archivo XML';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Función para manejar el envío del formulario
    const handleSubmit = async () => {
        if (!validateForm()) return;

        try {
            setLoading(true);
            const newProject = {
                ...buildXmlProjectData(formData.xmlFile),
                NameProject: formData.nombreProyecto,
                Client: clientData.cliente,
                Email: clientData?.email,
                TypeProject: formData.tipoProyecto,
            };

            const response = await ProjectsService.createProject(newProject);

            // Resetear formulario
            setFormData({
                nombreProyecto: '',
                tipoProyecto: '',
                xmlFile: null
            });
            setErrors({});

            // Llamar callback de éxito
            if (onProjectCreated) {
                onProjectCreated();
            }

        } catch (error) {

            // Llamar callback de error
            if (onProjectCreationError) {
                onProjectCreationError(error.message || 'Error al crear el proyecto');
            }
        } finally {
            setLoading(false);
        }
    };

    // Función para cerrar y resetear la modal
    const handleClose = () => {
        setFormData({
            nombreProyecto: '',
            tipoProyecto: '',
            xmlFile: null
        });
        setErrors({});
        onClose();
    };

    return (
        <ModalCS
            show={show}
            title="Crear Nuevo Proyecto"
            size="lg"
            handleClose={handleClose}
        >
            <div style={{ padding: '20px' }}>
                <form onSubmit={(e) => e.preventDefault()}>
                    {/* Campo Nombre del Proyecto */}
                    <div style={{ marginBottom: '20px' }}>
                        {/* <TextFieldCS
                            label="Nombre del Proyecto"
                            value={formData.nombreProyecto}
                            onChange={handleInputChange}
                            placeholder="Ingrese el nombre del proyecto"
                            required
                            fullWidth
                            error={!!errors.nombreProyecto}
                            helperText={errors.nombreProyecto}
                            style={{ minWidth: '200px' }}
                        /> */}
                        <TextFieldCS
                            id="nombreProyecto"
                            name="nombreProyecto"
                            label="Nombre del Proyecto"
                            value={formData.nombreProyecto}
                            onChange={handleInputChange}
                            style={{ minWidth: '200px' }}
                        />
                    </div>

                    {/* Campo Tipo de Proyecto */}
                    <div style={{ marginBottom: '20px' }}>
                        <DropDownListCS
                            id="tipoProyecto"
                            name="tipoProyecto"
                            label="Tipo de Proyecto"
                            items={projectTypes}
                            value={formData.tipoProyecto}
                            onChange={handleInputChange}
                            required
                            fullWidth
                            error={!!errors.tipoProyecto}
                            helperText={errors.tipoProyecto}
                            loading={loading}
                        />
                    </div>

                    {/* Campo Carga de Archivo XML */}
                    <div style={{ marginBottom: '20px' }}>
                        {
                            !formData.file && (
                                <>
                                    <div style={{ marginBottom: '8px' }}>
                                        <label style={{
                                            display: 'block',
                                            fontWeight: 'bold',
                                            marginBottom: '5px',
                                            color: '#333'
                                        }}>
                                            Archivo XML *
                                        </label>
                                    </div>
                                    <input
                                        type="file"
                                        accept=".xml,text/xml"
                                        onChange={handleFileChange}
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            border: `1px solid ${errors.xmlFile ? '#f44336' : '#ddd'}`,
                                            borderRadius: '4px',
                                            fontSize: '16px',
                                            backgroundColor: '#fff'
                                        }}
                                    />
                                </>
                            )
                        }
                        {formData.file && (
                            <div style={{
                                marginTop: '5px',
                                fontSize: '14px',
                                color: '#666',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}>
                                <span>Archivo seleccionado: {formData.file.name || 'Archivo XML'}</span>
                                {!loadingFile &&
                                    <button
                                        type="button"
                                        onClick={handleRemoveFile}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            color: '#f44336',
                                            cursor: 'pointer',
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            padding: '0 5px',
                                            marginLeft: '10px'
                                        }}
                                        title="Eliminar archivo"
                                    >
                                        ✕
                                    </button>
                                }
                            </div>
                        )}
                        {errors.xmlFile && (
                            <div style={{
                                color: '#f44336',
                                fontSize: '12px',
                                marginTop: '5px'
                            }}>
                                {errors.xmlFile}
                            </div>
                        )}
                    </div>

                    {/* Botones */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '10px',
                        marginTop: '30px'
                    }}>
                        <Button
                            variant="outlined"
                            onClick={handleClose}
                            style={{ minWidth: '100px' }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            disabled={loading || !isFormValid()}
                            style={{ minWidth: '100px' }}
                        >
                            {loading ? 'Cargando...' : 'Crear Proyecto'}
                        </Button>
                    </div>
                </form>
            </div>
        </ModalCS>
    );
};

CreateProjectDialog.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onProjectCreated: PropTypes.func,
    onProjectCreationError: PropTypes.func,
    clientData: PropTypes.object
};

export default CreateProjectDialog;
